// @flow
import * as React from "react";
import { Card, DownloadWidget, Section, DownloadFileBundleButton } from "buba-components";
import { INQUIRY_TYPE__GUARANTEE_AGENT } from "buba-components/src/utils/inquiryType";

import { type UploadedFiles } from "./BankInquiryDocuments";
import styles from "./Documents.scss";
import { downloadAllFilesV2 } from "../../api/v2actions";

type BankInquiryDownloadsProps = {
  downloadAction: any => Promise<any>,
  uploadedFiles: UploadedFiles,
  onError: number => void,
  refetchFiles: () => void,
  addMessage: (string, string) => void,
  inquiryProcessId: string
};

const BankInquiryDownloadsNew = ({
  downloadAction,
  onError,
  refetchFiles,
  uploadedFiles,
  addMessage,
  inquiryProcessId
}: BankInquiryDownloadsProps) => {
  const uploadedByGuaranteeAgent = uploadedFiles.filter(({ uploadedBy }) => {
    return uploadedBy.type === INQUIRY_TYPE__GUARANTEE_AGENT;
  });

  const shouldDisplayGuaranteeAgentUploads = !!uploadedByGuaranteeAgent.length;

  return (
    <Section title="Download-Bereich" numbered reducedMargin>
      <Card>
        {/* Documents from BUBA */}
        <div className={styles.downloadSectionHeaderContainer}>
          <header>Unterlagen von der Bürgschaftsbank</header>
          {!!uploadedByGuaranteeAgent.length && (
            <DownloadFileBundleButton
              downloadBundleAction={downloadAllFilesV2}
              addMessage={addMessage}
              inquiryProcessId={inquiryProcessId}
            />
          )}
        </div>
        <div className={styles.widgetContainer}>
          {uploadedByGuaranteeAgent.map(file => (
            <DownloadWidget
              downloadAction={downloadAction}
              errorCallback={onError}
              filename={file.fileName}
              id={Number(file.id)}
              key={file.id}
              status={file.downloadedByBankAdvisorAt ? "downloaded" : "uploaded"}
              title={file.description || file.fileName}
              successCallback={refetchFiles}
              uploadDate={file.createdAt}
            />
          ))}

          {!shouldDisplayGuaranteeAgentUploads && (
            <p>Aktuell stehen keine Unterlagen zum Download bereit.</p>
          )}
        </div>
      </Card>
    </Section>
  );
};

export default BankInquiryDownloadsNew;
